import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import Backend from "i18next-chained-backend";
import LocalStorageBackend from "i18next-localstorage-backend";

/*
When adding new text to the project, follow the following steps:
1. check in public/locales/en/translation whether the desired text already exist.
2. if yes, use the key along with TextLocalize component or translation function in order to display your text.
3. if not, add new key to public/locales/en/translation and public/locales/he/translation with the correct translation.
4. return to i18n.js
5. update translations versions in order to load the new translation files.
 */

const DETECTION_OPTIONS = {
  order: ["localStorage"],
  caches: ["localStorage"],
};

i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .use(LanguageDetector)
  .init({
    ns: ["translation", "enums"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      backends: [LocalStorageBackend, HttpApi],
      backendOptions: [
        {
          expirationTime: 7 * 24 * 60 * 60 * 1000,
          versions: { en: "v1.4.901125", he: "v1.4.901111" }, //when updating the translation files update the version
        },
      ],
    },
    react: {
      useSuspense: false,
    },
    detection: DETECTION_OPTIONS,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18next;

